var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 16c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7m10.707 2.293-3.682-3.682A8.95 8.95 0 0 0 18 9c0-4.962-4.037-9-9-9S0 4.038 0 9s4.037 9 9 9a8.95 8.95 0 0 0 5.611-1.975l3.682 3.682a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414"
})));
export default SvgSearch;